var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('v-alert',{staticClass:"text-body-2 text--secondary",attrs:{"border":"top","colored-border":"","color":"red","elevation":"2"}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }